import Container from '../UI/Container/Container'
import Layout from '../UI/Layout/Layout'
import './legal.css'

const Impressum = () => {
  return (
    <Layout authLevelRequired={false}>
      <Container>
        <div className="legal-text my-24">
          <h1>Impressum</h1>

          <p>
            Donata von Hardenberg
            <br />
            Corneliusstraße 3
            <br />
            10787 Berlin
          </p>

          <h2>Kontakt</h2>
          <p>E-Mail: mail@donatahardenberg.de</p>

          {/* <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz:
            <br />
            DE999999999
          </p> */}

          <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
          <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </div>
      </Container>
    </Layout>
  )
}

export default Impressum
